import loginProps from "common/managers/loginProps";

export default {

    compare: function(a, b) {

        var obj_str = '[object Object]';

        var a_type = Object.prototype.toString.apply(a);
        var b_type = Object.prototype.toString.apply(b);

        if (this.isArray(a) && this.isArray(b)) {
            return this.compareArray(a, b);
        } else if (a_type === obj_str && b_type === obj_str) {
            return this.compareObject(a, b);
        } else {
            return a === b;
        }

    },

    compareArray: function(arrayA, arrayB) {

        if (arrayA === arrayB) {
            return true;
        } else if (!this.isArray(arrayA) || !this.isArray(arrayB)) {
            return false;
        } else if (arrayA.length !== arrayB.length) {
            return false;
        } else {
            //The intention of this code is to compare values without caring about the particular order
            //This just plain won't work for complex items, however.
            //sort will give inconsistent results if you try to sort an array containing objects
            var copyA = arrayA.slice().sort();
            var copyB = arrayB.slice().sort();
            return copyA.every(function(a, i) {
                return this.compare(a, copyB[i]);
            }, this);
        }
    },

    compareObject: function(objA, objB) {
        if (objA === objB) {
            return true;
        } else {
            var keysA = Object.keys(objA);
            var keysB = Object.keys(objB);
            if (!this.compareArray(keysA, keysB)) {
                return false;
            } else {
                return keysA.every(function(key) {
                    return this.compare(objA[key], objB[key]);
                }, this)
            }
        }
    },

    isArray: function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]' || obj instanceof kendo.data.ObservableArray;
    },

    arrayDelimiter: function() {
        var ret = ",";
        if (loginProps && loginProps.get() && loginProps.get().searchingDelimiterIn) {
            ret = loginProps.get().searchingDelimiterIn;
        }
        return ret;
    }
};
